// https://github.com/mui/material-ui/issues/33424

import { Theme } from '@mui/material/styles';

function container() {
  return document.getElementById('root');
}

export default function MuiDialog(theme: Theme) {
  return {
    MuiDialog: {
      defaultProps: {
        container,
      },
      styleOverrides: {
        paper: {
          borderRadius: 16,
          border: `1px solid ${theme.palette.divider}`,
          backgroundImage: 'none',
        },
        paperFullScreen: {
          borderRadius: 0,
          border: 'none',
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontSize: '1.25rem',
          fontWeight: 700,
          letterSpacing: '-0.01em',
        },
      },
    },
  };
}
